import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import( /* webpackChunckName: "services-snapchat" */'./index')
);

export default prerenderedLoadable(Page);
